<template>
  <div class="date-box">
    <div class="date-arrow arrow-prev">
      <van-icon name="arrow-left" @click="prev" />
    </div>
    <div class="date-show" @click="showSelectPicker">{{ currentDate }}</div>
    <div class="date-arrow arrow-next">
      <van-icon name="arrow" @click="next" :class="hasNext() ? '' : 'disabled'" />
    </div>
    <van-popup v-model="showPicker" position="bottom" get-container="#app">
      <van-datetime-picker v-model="pickerValue" title="选择日期" :max-date="maxDate" type="date" @confirm="pickerConfirm" @cancel="pickerCancel" swipe-duration="100"/>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    value: {
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      showPicker: false,
      pickerValue:new Date(),
      maxDate: new Date()
    };
  },
  computed: {
    currentDate: {
      get() {
        return  moment(this.value).format('MM/DD') ;
      }
      // set(value) {
      //   this.$emit('input', moment(value).format('YYYY-MM-DD'));
      //   this.$emit('change', moment(value).format('YYYY-MM-DD'));
      // }
    },
  },
  methods: {
    showSelectPicker() {
      this.showPicker = true;
      this.pickerValue = new Date(this.value);
    },
    pickerConfirm(e) {
      this.$emit('input', moment(e).format('YYYY-MM-DD'));
      this.$emit('change', moment(e).format('YYYY-MM-DD'));
      this.showPicker = false;
    },
    pickerCancel() {
      this.showPicker = false;
    },
    // 前一天
    prev() {
      this.$emit(
        'input',
        moment(this.value)
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
      );
      this.$emit(
        'change',
        moment(this.value)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      );
    },
    next() {
      if (new Date(this.value) < new Date(moment(new Date()).format('YYYY-MM-DD'))) {
        this.$emit(
          'input',
          moment(this.value)
            .add(1, 'days')
            .format('YYYY-MM-DD')
        );
        this.$emit(
          'change',
          moment(this.value)
            .add(1, 'days')
            .format('YYYY-MM-DD')
        );
      }
    },
    hasNext() {
      if (new Date(this.value) < new Date(moment(new Date()).format('YYYY-MM-DD'))) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.date-box {
  // flex: 1;
  // width: 4.9rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #333;
  font-size: 0.875rem;
}
.date-arrow {
  color: #333;
  .disabled {
    color: #ccc;
  }
}
</style>
